export const environment = {
	name: 'dev',
	production: false,
	apiBaseUrl: 'https://paxi-express-api--gateway-86h937zf.ew.gateway.dev',
	// WAITING on below to resolve:
	// apiBaseUrl: 'https://express-api-dev.paxi.co.za',
	apiKey: 'AIzaSyD8xO83cwH6S8ZO7vCwDe9XmbBm60feqTY',
	firebaseConfig: {
		apiKey: "AIzaSyCq7vp8AgJDKmxdQVneTiyPfP4w7mjrWPE",
		authDomain: "grp-serv-digi-dev-paxi.firebaseapp.com",
		projectId: "grp-serv-digi-dev-paxi",
		storageBucket: "grp-serv-digi-dev-paxi.appspot.com",
		messagingSenderId: "641017198635",
		appId: "1:641017198635:web:84873d0dff594eeb7f526e",
		measurementId: "G-41D3ZWPF2L"
	}
};
